// extracted by mini-css-extract-plugin
export default {"nav":"AdminLayout_nav__D0-Q8","page":"AdminLayout_page__LFO42"};